/**
 * Release notes shown in the "Čo je nové" window on the login page. The newest release goes first and
 * its number is the app version. Written in Slovak only, for users, not developers.
 * Keep backend/app/main.py `version=` in step with APP_VERSION.
 */
export interface ReleaseNote {
  version: string;
  date: string;
  changes: { title: string; description: string }[];
}

export const CHANGELOG: ReleaseNote[] = [
  {
    version: '1.5.1',
    date: '28. 10. 2026',
    changes: [
      {
        title: 'Spotreba podľa technického preukazu',
        description: 'Pri každom aute zadáte kombinovanú spotrebu z TP a objem nádrže.',
      },
      {
        title: 'Štýl jazdy',
        description: 'Na stránke Palivo vidíte, či sa auto tankuje častejšie, než by podľa TP malo – hospodárna jazda, zvýšená spotreba alebo agresívna jazda.',
      },
    ],
  },
  {
    version: '1.5.0',
    date: '28. 10. 2026',
    changes: [
      {
        title: 'Palivo',
        description: 'Nová stránka s prehľadom tankovania – koľko litrov a eur minulo každé auto za mesiac, štvrťrok alebo rok.',
      },
      {
        title: 'Import zo Shell karty',
        description: 'Export transakcií zo Shell / Fleetcor (CSV alebo Excel) stačí nahrať. Opakovaný import toho istého obdobia nič nezdvojí.',
      },
      {
        title: 'Spotreba áut',
        description: 'Spotreba v litroch na 100 km sa vypočíta z natankovaných litrov a kilometrov z GPS.',
      },
      {
        title: 'Tankovanie v hotovosti',
        description: 'Tankovanie zaplatené v hotovosti alebo inou kartou pridáte ručne – stačí suma s DPH, zvyšok sa dopočíta.',
      },
      {
        title: 'Palivo v nákladoch',
        description: 'Palivo (bez DPH) a nákupy na pumpe sa započítavajú do nákladov každého auta.',
      },
      {
        title: 'Kontrola paliva',
        description: 'Upozornenie, ak sa do auta natankuje iné palivo, než má zapísané (napr. benzín do naftového).',
      },
    ],
  },
  {
    version: '1.4.0',
    date: '28. 10. 2026',
    changes: [
      {
        title: 'Automatické GPS',
        description: 'Dvakrát denne (o 12:00 a 20:00) sa z GPSPOLOHA samé stiahnu jazdy a kilometre každého auta – bez nahrávania súborov.',
      },
      {
        title: 'Kde je auto',
        description: 'Pri každom aute vidíte, kde naposledy zaparkovalo, a jedným klikom ho otvoríte na mape.',
      },
      {
        title: 'Stiahnuť teraz',
        description: 'Na stránke GPS jazdy si aktuálne údaje stiahnete kedykoľvek aj ručne.',
      },
    ],
  },
  {
    version: '1.3.0',
    date: '26. 10. 2026',
    changes: [
      {
        title: 'Náklady na autá',
        description: 'Prehľad, koľko stojí každé auto – servisy, diaľničné známky a pokuty spolu, aj cena na kilometer.',
      },
      {
        title: 'Dlaždicové zobrazenie',
        description: 'Ikonou v hlavičke prepnete aplikáciu na prehľadnú mriežku veľkých dlaždíc.',
      },
      {
        title: 'Slovenčina, angličtina, nemčina',
        description: 'Aplikáciu si môžete prepnúť do troch jazykov, aj priamo na prihlasovacej stránke.',
      },
      {
        title: 'E-mailové upozornenia',
        description: 'V časti Môj účet si zadáte e-mail a vyberiete, o čom chcete dostávať správy.',
      },
      {
        title: 'Presúvanie rezervácií',
        description: 'Rezerváciu v kalendári stačí potiahnuť myšou na iné dni. Omylom presunutú vrátite tlačidlom Späť.',
      },
      {
        title: 'Pripravujeme',
        description: 'Faktúry z doklado.sk a tankovanie z kariet Shell (Fleetcor) priamo v nákladoch.',
      },
    ],
  },
  {
    version: '1.2.0',
    date: '28. 9. 2026',
    changes: [
      {
        title: 'Rezervácie áut',
        description: 'Kalendár dostupnosti: zelená je voľné, žltá rezervované, červená požičané.',
      },
      {
        title: 'Zmluvy',
        description: 'Zmluva o nájme auta sa vytvorí jedným klikom ako dokument Word.',
      },
      {
        title: 'Kniha jázd z GPS',
        description: 'Mesačné výpisy z GPSPOLOHA sa nahrajú ku každému autu – kilometre, miesta a jazdy.',
      },
      {
        title: 'Diaľničné známky',
        description: 'Známky pre Slovensko a ďalšie krajiny EÚ, s upozornením, keď sa blíži koniec platnosti.',
      },
      {
        title: 'Pokuty',
        description: 'Evidencia pokút – kto, kedy, koľko a kto ju zaplatil.',
      },
      {
        title: 'Pneumatiky',
        description: 'Letné, zimné a celoročné pneumatiky prehľadne na obrázku auta.',
      },
      {
        title: 'Plán údržby',
        description: 'Ukazovatele ukážu, kedy auto čaká servis a STK/EK.',
      },
    ],
  },
];

export const APP_VERSION = CHANGELOG[0].version;
